import React from 'react';
import logo from './login_logo.png';

import styles from './Header.module.css';

const Header = () => (
  <div className={styles.container}>
    <img className={styles.logo} alt="Sierra Wireless" src={logo} />
  </div>
);

export default Header;
